import { useEffect, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { generatePath } from 'react-router-dom'
import { mdiArrowLeft } from '@mdi/js'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import ROUTES from 'app/routes'

import SubscriptionTable from '../SubscriptionTable'
import { subscriptionDetailsMessages } from './messages'
import {
  SubsDetailsBackIcon,
  SubsDetailsBackLink,
  SubsDetailsHeading,
} from './styles'
import { useHomeRouteParams } from 'features/home/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import {
  fetchHomeSubscriptionPriceThunk,
  fetchSubscriptionPeriodEndSliceSliceThunk,
} from './slice'
import SubscriptionPlanDetails from '../SubscriptionPlanDetails'

function SubscriptionDetails() {
  const { homeId } = useHomeRouteParams()
  const dispatch = useAppDispatch()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  useEffect(() => {
    dispatch(fetchHomeSubscriptionPriceThunk(homeId))
    dispatch(fetchSubscriptionPeriodEndSliceSliceThunk(homeId))
  }, [dispatch, homeId])

  const subscriptionPath = useMemo(
    () =>
      generatePath(ROUTES.homeSubscription.root(), {
        homeId,
        rootDomainId: currentRootId || '',
      }),
    [currentRootId, homeId]
  )

  return (
    <div>
      <SubsDetailsBackLink to={subscriptionPath}>
        <SubsDetailsBackIcon path={mdiArrowLeft} size={1} />
        <FormattedMessage {...subscriptionDetailsMessages.backLink} />
      </SubsDetailsBackLink>
      <SubsDetailsHeading>
        <FormattedMessage {...subscriptionDetailsMessages.title} />
      </SubsDetailsHeading>
      <SubscriptionPlanDetails isHomeDashboard={false} />
      <SubscriptionTable />
    </div>
  )
}

export default SubscriptionDetails
